const FilterAdjustmentSvg = ({
  height = 17,
  width = 17,
  viewBox = '0 0 17 17',
  stroke = 'currentColor',
}: {
  height?: number | string;
  width?: number | string;
  viewBox?: string;
  stroke?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0833 14.9605V12.5921M15.75 9.43421H12.4167M14.0833 9.43421V0.75M8.25 3.90789V0.75M9.91667 7.06579H6.58333M8.25 15.75V7.06579M2.41667 14.9605V12.5921M4.08333 9.43421H0.75M2.41667 9.43421V0.75"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FilterAdjustmentSvg;
